import {
  ReactThreeFiber,
  extend,
  useLoader,
  useThree,
} from '@react-three/fiber';
import { useEffect } from 'react';
import {
  EquirectangularReflectionMapping,
  SRGBColorSpace,
  TextureLoader,
} from 'three';
// eslint-disable-next-line no-restricted-imports
import { GroundedSkybox } from 'three/examples/jsm/objects/GroundedSkybox';

import { useFade } from 'contexts/Fade';

extend({ GroundedSkybox });
declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      groundedSkybox: ReactThreeFiber.Object3DNode<
        GroundedSkybox,
        typeof GroundedSkybox
      >;
    }
  }
}
type Props = {
  url: string;
  height?: number;
  radius?: number;
} & React.JSX.IntrinsicElements['group'];

export const GroundEnvironment = ({
  url,
  height = 2,
  radius = 10,
  ...props
}: Props) => {
  const { scene } = useThree();
  const envMap = useLoader(TextureLoader, url);
  envMap.mapping = EquirectangularReflectionMapping;
  envMap.colorSpace = SRGBColorSpace;
  const { addFadeMaterial } = useFade();
  useEffect(() => {
    if (envMap) {
      scene.environment = envMap;
    }
  }, [envMap, scene]);
  return (
    <group {...props}>
      <groundedSkybox args={[envMap, height, radius]} position-y={height}>
        <meshBasicMaterial
          map={envMap}
          depthWrite={false}
          ref={addFadeMaterial}
        />
      </groundedSkybox>
    </group>
  );
};
